// extracted by mini-css-extract-plugin
export default {"BannerInfo":"BannerInfo_BannerInfo__qnuVo"};